var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.srcoll_flag_state),expression:"srcoll_flag_state"}],staticClass:"back-card",on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":_vm.defaultSrc,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }